import FiltersHeader from "../../../../Helper/filtersHeader";
import * as Constants from '../../../../Helper/constants/constants';
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Calender, ChangePatientProfile, Image_Up, Man, Patient } from "../../../../../assets/images";
import Select from 'react-select';
import { useState } from "react";
import TagsInput from "react-tagsinput";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import { useNavigate } from "react-router-dom";
import AddDepartmentFunctions from "./function";
import { useEffect } from "react";

const AddDepertment = () => {
    const navigate = useNavigate();
    const {
        getHospitalListing,
        breadcrumData,
        breadcrumItem,
        values,
        isError,
        hospitalsListing,
        loader,
        handleChange,
        submitDepartement,
        loaction,
        setbreadcrumItem,
        handleBreadcrumDataNaviagtion
    } = AddDepartmentFunctions();


    useEffect(() => {
        if (!loader) {

            getHospitalListing();
        }
    }, [values.state]);


    return (
        <div className="add_case_section">
            <WithoutImageHeader
                header={Constants.ADDDEPARTMentT}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                handleBack={() => navigate(-1)}
                handleBreadcrumDataNaviagtion={(i) => handleBreadcrumDataNaviagtion(i)}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="case_area">
                            <div className="dropdown_box">
                                <h6>Hospital<span>*</span></h6>
                                <div className="dropdown_area">
                                    <Select
                                        placeholder="General Patient"
                                        options={hospitalsListing}
                                        value={values && values.hospital_arr}
                                        onChange={(e) => {
                                            handleChange("hospital_arr", e);
                                        }}
                                    />
                                    {isError.hospital_arr.message ? (
                                        <p className="text-danger mt-2">
                                            {isError.hospital_arr.message}
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <Form.Group className="form-group">
                                <Form.Label>Department Title<span>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Type Here"
                                    className={
                                        isError.department_title.message
                                            ? "error_border"
                                            : ""
                                    }
                                    value={values.department_title}
                                    onChange={(e) =>
                                        handleChange(
                                            "department_title",
                                            e.target.value
                                        )
                                    }
                                />
                                {isError.department_title.message ? (
                                    <p className="text-danger mt-2">
                                        {isError.department_title.message}
                                    </p>
                                ) : null}
                            </Form.Group>
                            <div className="btn_area">
                                <Button
                                    className="cancelBtn"
                                    type="button"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="button"
                                    onClick={() => submitDepartement()}
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default AddDepertment;